import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scrolls to the element matching `location.hash` on hash change.
 * Initial jump is instant so the final position stays accurate even if images
 * above the target load late and shift layout; a delayed smooth re-align then
 * settles into the precise position once layout has stabilized.
 *
 * Smooth-only approaches drift on this page because `scrollIntoView` locks in
 * the target's absolute Y at call time and does not track later layout shifts.
 */
export function useHashScroll(realignDelayMs = 400) {
  const location = useLocation()

  useEffect(() => {
    if (!location.hash) return
    const id = decodeURIComponent(location.hash.slice(1))
    const el = document.getElementById(id)
    if (!el) return
    el.scrollIntoView({ behavior: 'auto' })
    const timer = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    }, realignDelayMs)
    return () => clearTimeout(timer)
  }, [location.hash, realignDelayMs])
}
